import React, { useState } from 'react'
import { useTranslate, Form } from 'react-admin'
import LoadingButton from '@mui/lab/LoadingButton'
import SaveIcon from '@mui/icons-material/Save'
import { ShowListElement } from 'src/components/uiElements/CRUD/ShowListElement'
import { Grid } from '@mui/material'
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Skeleton,
  DialogActions,
  Box,
  Button,
  CircularProgress,
  Autocomplete,
  TextField,
} from '@mui/material'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { useCardId } from 'src/components/pages/sales/reservation/context/CardIdContext'
import { workUnitServices } from 'src/services/reservation/workUnit/WorkUnit.service'
import { getAllChildrensId } from 'src/components/pages/sales/business-rule/logic/commonFunctions/getAllChildrensId'
import { businessUnitServices } from 'src/services/reservation/businessUnit/businessUnit.service'
import { Search } from '@mui/icons-material'
export const ReAssignModal = ({
  open,
  handleClose,
  titleModal,
  actionButtonLoading,
  avoid = ['created_at', 'updated_at'],
  onSubmitCustom,
  work_unit_id,
}) => {
  const translate = useTranslate()
  const [loadingClients, setLoadingClients] = useState(false)
  const [timeoutClients, setTimeoutClients] = useState()
  const [clients, setClients] = useState([])
  const [searchBy, setSearchBy] = useState(null)
  const [businessUnitSelect, setBusinessUnitSelect] = useState(null)

  const { cardId } = useCardId()
  const onSubmit = (data) => {
    const record_with_update_busines_unit = {
      ...data,
      business_unit_id: businessUnitSelect?.id,
      work_unit_id: businessUnitSelect?.work_unit_id,
      user_id: businessUnitSelect?.user_id,
    }
    onSubmitCustom && onSubmitCustom(record_with_update_busines_unit, cardId)
    setBusinessUnitSelect(null)
    setSearchBy(null)
    setClients([])
  }

  const hadId = (str) => {
    return str.includes('_id') || str.includes('id_')
  }

  const getWorkUnitByid = async (id) => {
    try {
      const work_unit = await workUnitServices.getAllChildren(id)
      if (work_unit) {
        return work_unit.data
      }
      return null
    } catch (error) {
      console.log('getWorkUnitByid error', error)
    }
  }

  const showKeys = (business_unit) => {
    let string = ''
    const business_name = business_unit?.fiscal_data_relation?.name || business_unit?.fiscal_data_name
    const fantasy_name = business_unit?.fantasy_name
    const long_name = business_unit?.long_name

    if (business_name) {
      string += '(RS) ' + business_name
    }
    if (fantasy_name) {
      string += (business_name ? ' - (NF) ' : '') + fantasy_name
    }
    if (long_name) {
      string += (business_name || fantasy_name ? ' - (NL) ' : '') + long_name
    }

    return string
  }

  const handleInput = (event) => {
    if (searchBy === 'id') {
      const value = event.target.value
      // sacar caracteres que no sean números
      const numericValue = value.replace(/[^0-9]/g, '')
      if (value !== numericValue) {
        event.target.value = numericValue
        event.preventDefault()
      }
    }
  }

  const onChangeClient = (value) => {
    clearTimeout(timeoutClients)
    if (value && work_unit_id && searchBy) {
      const timeout = setTimeout(async () => {
        setLoadingClients(true)
        const work_unit = await getWorkUnitByid(work_unit_id)
        if (!work_unit) {
          return
        }
        /* const workUnitIds = getAllChildrensId(work_unit) */
        let params = {}
        if (isNaN(value)) {
          params[searchBy] = value
          params['work_unit_id__in'] = work_unit.join(',')
        } else {
          params['id'] = value
          params['work_unit_id__in'] = work_unit.join(',')
        }
        try {
          const response = await businessUnitServices.business_unit_filter(params)
          setClients(response)
        } catch (error) {
          setClients([])
        } finally {
          setLoadingClients(false)
        }
      }, 1000)
      setTimeoutClients(timeout)
    } else {
      setClients([])
    }
  }

  const onChangeSelectedClient = (client) => {
    setBusinessUnitSelect(client)
  }

  return (
    <Dialog open={open} maxWidth='lg' fullWidth={true}>
      <DialogTitle>{titleModal}</DialogTitle>
      <DialogContent>
        <Form id='post_create_form' onSubmit={onSubmit}>
          <Grid container item marginTop={'10px'}>
            <EditInputsWrap md={3} lg={3} label={translate('ra.field.search_by')}>
              <Autocomplete
                size='small'
                options={[
                  {
                    id: 'fantasy_name__ilike',
                    name: translate('ra.field.fantasy_name'),
                  },
                  {
                    id: 'fiscal_data__name__ilike',
                    name: translate('ra.field.business_name'),
                  },
                  {
                    id: 'long_name__ilike',
                    name: translate('ra.field.long_name'),
                  },
                  {
                    id: 'id',
                    name: translate('ra.field.id'),
                  },
                ]}
                renderInput={(params) => <TextField {...params} label='' />}
                getOptionLabel={(option) => option.name}
                noOptionsText={translate('ra.validation.noOptionsText')}
                placeholder={translate('ra.field.search_by')}
                onChange={(e, value) => {
                  setSearchBy(value?.id)
                  setClients([])
                }}
              />
            </EditInputsWrap>
            <EditInputsWrap md={9} lg={9} className='input-gray'>
              <Autocomplete
                size='small'
                options={clients || []}
                getOptionLabel={(option) => showKeys(option)}
                loading={loadingClients}
                loadingText={translate('ra.action.loading')}
                filterOptions={() => clients}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder={translate('ra.field.search_client')}
                    onChange={(e) => onChangeClient(e.target.value)}
                    onInput={handleInput}
                    InputProps={{
                      ...params.InputProps,
                      startAdornment: <Search />,
                      endAdornment: (
                        <>
                          {loadingClients ? <CircularProgress color='inherit' size={20} /> : null}
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
                onChange={(e, value) => onChangeSelectedClient(value)}
                noOptionsText={translate('ra.validation.noOptionsText')}
                placeholder={translate('ra.field.search_client')}
                disabled={!searchBy}
              />
            </EditInputsWrap>
          </Grid>
        </Form>
        <Box padding={'5px 20px'}>
          <Grid container spacing={3}>
            {businessUnitSelect &&
              Object.keys(businessUnitSelect || {}).map((prop, i) => {
                if (
                  !Array.isArray(businessUnitSelect[prop]) &&
                  typeof businessUnitSelect[prop] !== 'object' &&
                  avoid &&
                  !avoid.includes(prop) &&
                  !hadId(prop)
                ) {
                  return (
                    <ShowListElement
                      key={i}
                      label={translate(`ra.field.${prop}`)}
                      value={businessUnitSelect[prop]}
                      type={typeof businessUnitSelect[prop] === 'boolean' ? 'boolean' : ''}
                    />
                  )
                }

                return null
              })}
          </Grid>
        </Box>
        <DialogActions className='dialog-actions' style={{ marginTop: '20px' }}>
          <LoadingButton
            loading={actionButtonLoading}
            variant='contained'
            startIcon={<SaveIcon />}
            form='post_create_form'
            type='submit'
            disabled={!businessUnitSelect}
          >
            {translate('ra.action.save')}
          </LoadingButton>
          <Button
            onClick={() => {
              handleClose()
              setBusinessUnitSelect(null)
              setSearchBy(null)
              setClients([])
            }}
            variant='outlined'
            color='error'
          >
            {translate('ra.action.cancel')}
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  )
}
